import axios from "axios";
import { clearAuthSession, isRecentSessionClear } from "../utils/authSession";
import { ROUTES } from "../routes/paths";

/**
 * Ensures requests hit `/api/...` on the backend. Values like `http://localhost:5007`
 * (missing `/api`) produce 404 from Express because routes are mounted under `/api`.
 */
function normalizeApiBaseUrl(raw) {
  const fallback = "http://localhost:5005/api";
  if (raw == null || String(raw).trim() === "") return fallback;
  let base = String(raw).trim().replace(/\/+$/, "");
  if (!base) return fallback;
  if (/\/api$/i.test(base)) return base;
  return `${base}/api`;
}

if (process.env.NODE_ENV === "production" && !process.env.REACT_APP_API_BASE_URL) {
  // A production build with no REACT_APP_API_BASE_URL silently targets localhost — fail loudly instead.
  // eslint-disable-next-line no-console
  console.error(
    "REACT_APP_API_BASE_URL is not set in this production build. API calls will target localhost and fail. " +
      "Set REACT_APP_API_BASE_URL at build time (see docs/HOSTINGER_DEPLOYMENT_GUIDE.md)."
  );
}

const apiBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);

/** Origin only (no /api), for building absolute file/report URLs */
export const apiOrigin = apiBaseUrl.replace(/\/?api\/?$/i, "");

const API = axios.create({
  baseURL: apiBaseUrl
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    const url = String(err.config?.url || "");
    if (status === 401) {
      const isAuthForm = url.includes("/auth/login") || url.includes("/auth/register");
      if (!isAuthForm && !isRecentSessionClear()) {
        clearAuthSession();
        const path = typeof window !== "undefined" ? window.location.pathname : "";
        if (path && path !== ROUTES.LOGIN && path !== ROUTES.REGISTER) {
          window.location.assign(`${window.location.origin}${ROUTES.LOGIN}`);
        }
      }
    }
    return Promise.reject(err);
  }
);

export default API;

